import React from 'react'
import Icon from 'decorators/Icon'

// eslint-disable-next-line react/prop-types
const IconEdit = ({ t, className, height, width, fill }) => (
  <svg className={className} width={width} height={height} viewBox='0 0 34 34'>
    <title>{t('Edit')}</title>
    <g transform='translate(-3 -3)' fill='none' fillRule='evenodd'>
      <rect width={39} height={39} rx={5} />
      <path
        d='M33 12.289l-2.115 2.115-5.29-5.296 2.115-2.116a1.168 1.168 0 0 1 1.614 0L33 10.675c.444.444.444 1.17 0 1.614zM15.322 29.988l-5.29-5.297 13.676-13.696 5.29 5.297-13.676 13.696zM8.81 27.245l3.958 3.964-5.512 1.554 1.554-5.518zM34.888 8.788l-3.677-3.684c-.718-.718-3.311-2.077-5.381 0L7.197 23.75c-.163.164-.281.36-.34.582L4.05 34.33c-.13.463.006.96.34 1.306.339.346 1.018.405 1.306.34l9.992-2.815c.222-.059.418-.177.581-.34l18.62-18.646a3.82 3.82 0 0 0 0-5.388z'
        fill={fill}
        stroke={fill}
        strokeWidth={0.5}
      />
    </g>
  </svg>
)

export default Icon(IconEdit)
